import { ThemeIcon } from '@src/theme/ThemeIcon';
import type { IconProps } from '@src/components/icons/IconProps';

export function BoxIcon({ className }: IconProps) {
  return (
    <ThemeIcon name="box" className={className} fallback={<svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M9 11h6" />
      <rect x="3" y="3" width="18" height="4" rx="2" />
      <path d="M4 7h16v6c0 1.412 0 2.42-.055 3.215-.053.786-.156 1.29-.326 1.698a5 5 0 01-2.706 2.706c-.409.17-.912.273-1.698.326C14.42 21 13.412 21 12 21s-2.42 0-3.215-.055c-.786-.053-1.29-.156-1.698-.326a5 5 0 01-2.706-2.706c-.17-.409-.273-.912-.326-1.698C4 15.42 4 14.412 4 13V7z" />
    </svg>} />
  );
}
